export default __webpack_public_path__ + "static/media/delivery-dsk.87cfeb21.svg";